import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    demographic: [],
    smtp: [],
    team:{
        mates:[],
        total:0,
        limit:0
    },
    sacc:{
        mates:{
            team:[],
            inuse:{
                s:0,
                g:0,
                u:0
            }
        },
        total:0,
        limit:{
            total:0,
            ssa:0,
            gsa:0,
            usa:0
        }
    }
};

const profileSlice = createSlice({
    name: "pkzme",
    initialState,
    reducers: {
        fillProfile(state, action) {
            state.demographic = action.payload;
            state.smtp = action.payload.smtp;
        },
        fillTeam(state, action) {
            state.team = action.payload;
        },
        fillAccounts(state, action) {
            state.sacc = action.payload;
        },
        fillLogo(state, action) {
            state.demographic.brandLogo = action.payload;
        }        
    }
});

export const {fillProfile, fillTeam, fillAccounts, fillLogo} = profileSlice.actions;
export default profileSlice.reducer;